import { createAction, union } from '@ngrx/store';
import {
  zefActionPayload,
  zefActionFailPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';
import { Country, Currency, Language, Location, ObjectStorage } from '@zerops/models/settings';
import { ServiceStackType } from '@zerops/models/service-stack';

export const loadSettings = createAction(
  '[@zerops/zerops/core/settings-base] load-settings',
  zefActionPayload<string>()
);

export const loadSettingsFail = createAction(
  '[@zerops/zerops/core/settings-base] load-settings/fail',
  zefActionFailPayload
);

export const loadSettingsSuccess = createAction(
  '[@zerops/zerops/core/settings-base] load-settings/success',
  zefActionSuccessPayload<{
    currencyList: Currency[],
    languageList: Language[],
    serviceStackList: ServiceStackType[],
    locationList: Location[],
    objectStorageList: ObjectStorage[],
    objectStorageDiskGBytesMax: number
  }>()
);

export const loadCountryList = createAction(
  '[@zerops/zerops/core/settings-base] load-country-list',
  zefActionPayload()
);

export const loadCountryListFail = createAction(
  '[@zerops/zerops/core/settings-base] load-country-list/fail',
  zefActionFailPayload
);

export const loadCountryListSuccess = createAction(
  '[@zerops/zerops/core/settings-base] load-country-list/success',
  zefActionSuccessPayload<{
    list: Country[]
  }>()
);

export const loadStackTypeDetail = createAction(
  '[@zerops/zerops/core/settings-base] load-stack-type-detail',
  zefActionPayload<{ clientId: string; stackTypeId: string }>()
);

export const loadStackTypeDetailFail = createAction(
  '[@zerops/zerops/core/settings-base] load-stack-type-detail/fail',
  zefActionFailPayload
);

export const loadStackTypeDetailSuccess = createAction(
  '[@zerops/zerops/core/settings-base] load-stack-type-detail/success',
  zefActionSuccessPayload<ServiceStackType>()
);

export const measureLocationPings = createAction(
  '[@zerops/zerops/core/settings-base] measure-location-pings',
  zefActionPayload()
);

export const measureLocationPingsSuccess = createAction(
  '[@zerops/zerops/core/settings-base] measure-location-pings/success',
  zefActionSuccessPayload<{
    locationPingMap: Record<string, number | null>;
    fastestLocationId: string | null;
  }>()
);

const all = union({
  loadSettings,
  loadSettingsFail,
  loadSettingsSuccess,
  loadCountryList,
  loadCountryListFail,
  loadCountryListSuccess,
  loadStackTypeDetail,
  loadStackTypeDetailFail,
  loadStackTypeDetailSuccess,
  measureLocationPings,
  measureLocationPingsSuccess
});

export type SettingsBaseActionUnion = typeof all;
